import { SET_COMMENTS } from './actions';

import {
  likeComment as likeCommentCommon,
  unlikeComment as unlikeCommentCommon,
  addComment as addCommentCommon,
} from './dispatchers.common';
import { makeMetricsLogEvent } from '../Metrics/manualEventDispatchers';
import { checkFacialIdentity } from '../IdentitySession/dispatchers';

export function setComments(comments) {
  return (dispatch) => {
    dispatch({
      type: SET_COMMENTS,
      comments,
    });
  };
}

export function likeComment(commentId, appWidget = null) {
  return (dispatch) => {
    dispatch(
      makeMetricsLogEvent('UpVote-Made', {
        onObject: 'Comment',
        comment: commentId,
        appWidget,
      })
    );
    dispatch(likeCommentCommon(commentId));
  };
}

export function unlikeComment(commentId, appWidget = null) {
  return (dispatch) => {
    dispatch(
      makeMetricsLogEvent('DownVote-Made', {
        onObject: 'Comment',
        comment: commentId,
        appWidget,
      })
    );
    dispatch(unlikeCommentCommon(commentId));
  };
}

export function addComment(
  creationData,
  onSuccess,
  onFailure,
  appWidget = null
) {
  return (dispatch) => {
    dispatch(addCommentCommon(creationData)).then((comment) => {
      dispatch(checkFacialIdentity());
      onSuccess(comment);
      const depth = creationData.parentComment ? 1 : 0; // TODO: fix this when we have comment nesting in feed gallery
      dispatch(
        makeMetricsLogEvent('Comment-Made', {
          comment: comment.id,
          depth,
          onObject: 'Post',
          appWidget,
        })
      );
    }, onFailure);
  };
}
